export const SET_FLAGS = 'SET_FLAGS';
export const setFlags = (flags) => {
  return {
    type: SET_FLAGS,
    data: flags,
  };
};
